// ABOUTME: Things to post about, read off the business's own knowledge base (its content themes,
// then its services): the ideas onboarding's first ask and a fresh chat offer. Never a list in
// code; with no themes or services there are no ideas.
import { useEffect, useMemo } from 'react'
import { useBusinessKnowledgeBaseStore } from '@/stores/useBusinessKnowledgeBaseStore'

const IDEA_COUNT = 3

export function useBusinessIdeas(): string[] {
  const { kb, fetchKB } = useBusinessKnowledgeBaseStore()
  // Read fresh on mount: the website import may have filled the knowledge base since.
  useEffect(() => {
    void fetchKB()
  }, [fetchKB])
  return useMemo(() => {
    const services = (kb?.services ?? []).map((s) => String(s.name ?? '').trim())
    const topics = [...(kb?.content_pillars ?? []), ...services].filter(Boolean)
    return [...new Set(topics)].slice(0, IDEA_COUNT)
  }, [kb])
}

/** The ask an idea starts: "Home repair tips" reads "home repair tips" mid-sentence. */
export function ideaAsk(idea: string): string {
  const topic = /^[A-Z][a-z]/.test(idea) ? idea[0].toLowerCase() + idea.slice(1) : idea
  return `Make a post about ${topic}`
}
